// Module-level PWA install helper.
// Captures the beforeinstallprompt event as early as the app loads
// so any component (global banner, inline button) can trigger install
// with one tap without racing the browser event.

let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach((cb) => {
  try { cb(); } catch (e) {
    // A single listener throwing shouldn't break the rest of the chain
    console.warn('[pwaInstall] listener threw:', e);
  }
});

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });
}

export const isStandalone = () => {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
};

export const isIOS = () => {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(ua) && !window.MSStream;
};

export const isAndroid = () => {
  if (typeof window === 'undefined') return false;
  return /android/.test(window.navigator.userAgent.toLowerCase());
};

export const hasInstallPrompt = () => deferredPrompt !== null;

export const triggerInstall = async () => {
  if (!deferredPrompt) return { outcome: 'unavailable' };
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  notify();
  return choice; // { outcome: 'accepted' | 'dismissed' }
};

export const onInstallStateChange = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};
